import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <p>Research has also found that engagement has a direct impact on
                                                business outcomes.<sup><a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300">6</a></sup>
                                                Engaged employees have been found to: </p>
                                            <ul className="greenbullet-list">
                                                <li>Deliver better customer satisfaction</li>
                                                <li>Positively inﬂuence customer loyalty ratings</li>
                                                <li>Improve financial out-turn</li>
                                                <li>Show low levels of employee turnover.</li>
                                            </ul>

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>IMPROVING ENGAGEMENT
                                            </div>


                                            <p>Research by the Institute for Employment Studies (IES) found that
                                                what produces engagement
                                                more than anything else, is a sense of feeling valued and
                                                involved. For this, people need to: </p>

                                            <ul className="greenbullet-list">
                                                <li>Be involved in decision making</li>
                                                <li>Feel able to voice their ideas. Managers must listen to
                                                    these views and value employees'
                                                    contributions
                                                </li>
                                                <li>Have opportunities to develop within the organisation</li>
                                                <li>Feel that the organisation is concerned for their health and
                                                    wellbeing.
                                                </li>
                                            </ul>

                                            <p>Line managers play a vital role in fostering a sense of value and
                                                involvement through conducting
                                                performance appraisals, communicating with team members and
                                                other employees, identifying
                                                training opportunities and ensuring equality of
                                                opportunity. </p>
                                            <p>The IES found that feeling valued and involved at work is also
                                                linked to availability of training and
                                                development, the attitude and behaviour of managers, the manner
                                                of appraisals, communication,
                                                equal opportunities and fair treatment. </p>
                                            <p>Here is a model of 'engagement' devised by the IES, based on its
                                                most important contributors,
                                                which are 'feeling valued' and 'involved'. </p>

                                            <p className="para-first-pad" align="center"><img
                                                src={require('@images/Howtodirect-people-img.png')}/>
                                            </p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}